// src/store/modules/auth.js
import axios from "axios"; // Import Axios library
import { toast } from "vue3-toastify";
const authModule = {
    namespaced: true,
    state() {
        return {
            token: localStorage.getItem("token") || null,
            user: null,
            isAuthenticated: false,
        };
    },

    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem("token", token);
        },
        SET_USER(state, user) {
            state.user = user;
        },
        SET_AUTH_STATUS(state, isAuthenticated) {
            state.isAuthenticated = isAuthenticated;
        },
    },

    actions: {
        async login({ commit }, credentials) {
            try {
                const response = await axios.post("/api/login", credentials);
                commit("SET_TOKEN", response.data.token);
                commit("SET_USER", response.data.user);
                commit("SET_AUTH_STATUS", true);
                return { success: true, message: "Login successful" };
            } catch (error) {
                return { success: error, message: "Login failed", error };
            }
        },
        async signup({ commit }, credentials) {
            try {
                const response = await axios.post("/api/register", credentials);
                commit("SET_TOKEN", response.data.token);
                commit("SET_USER", response.data.user);
                commit("SET_AUTH_STATUS", true);
                return { success: true, message: "Login successful" };
            } catch (error) {
                return { success: error, message: "Login failed", error };
            }
        },
        async getUser({ commit, state, dispatch }) {
            const token = localStorage.getItem("token");
            if (token) {
                console.log("Token Available");
                commit("SET_AUTH_STATUS", true);
                if (state.user) {
                    return state.user;
                } else {
                    try {
                        const response = await axios.get("/api/user", {
                            headers: { Authorization: `Bearer ${token}` },
                        });
                        commit("SET_USER", response.data);
                        commit("SET_AUTH_STATUS", true);
                    } catch (error) {
                        if (error.response.status === 401) {
                            dispatch("logout");
                        }
                        console.log(error.response);
                    }
                }
            } else {
                console.log("Token Not Available");
                commit("SET_AUTH_STATUS", false);
            }
        },

        async updateProfile({ commit, state }, profileData) {
            try {
                const response = await axios.post(
                    "/api/update-profile",
                    profileData,
                    {
                        headers: { Authorization: `Bearer ${state.token}` },
                    }
                );
                commit("SET_USER", response.data.user);
                return response;
            } catch (error) {
                throw error.response ? error.response : error;
            }
        },

        async updatePassword({ commit }, passwordData) {
            const url = `/api/password/update`;
            const token = localStorage.getItem("token");
            try {
                const response = await axios.post(url, passwordData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                commit("SET_USER", response.data.user); // Update user info
                return response;
            } catch (error) {
                throw error; // Let the caller handle errors
            }
        },

        logout({ commit }) {
            // Perform logout actions, such as clearing token and user data
            commit("SET_TOKEN", null);
            commit("SET_USER", null);
            commit("SET_AUTH_STATUS", false);
            localStorage.removeItem("token");
        },

        async getUserImage({ state }) {
            const user = state.user;
            if (user && user.image) {
                return `${window.location.origin}${user.image}`; // Use the correct path for the image
            }
            return `${window.location.origin}/images/profile/avatar.png`; // Return a default image if none exists
        },
    },

    getters: {
        // Getter functions to access authentication state
        getToken: (state) => state.token,
        getUser: (state) => state.user,
        isAuthenticated: (state) => state.isAuthenticated,
        getUserImage: (state) => {
            const user = state.user;

            if (user && user.image) {
                const image = user.image;

                // Check if image is already an absolute URL
                const isAbsolute = /^(http|https):\/\//i.test(image);

                return isAbsolute
                    ? image
                    : `${window.location.origin}/${image.replace(/^\/+/, "")}`;
            }

            // Fallback to default avatar
            return `${window.location.origin}/images/profile/avatar.png`;
        },
    },
};

export default authModule;
